import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ResortDetailsMain from '../Components/Resort/ResortDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function ResortDetails() {
    return (
        <>
            <SEO 
                title="Resort Details - Tourm Travel Agency"
                description="View detailed information about our luxury resorts and accommodations."
                url="/resort"
            />
            <HeaderOne />
            <Breadcrumb
                title="Resort Details"
            />
            <ResortDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ResortDetails
